import { useQuery } from "@tanstack/react-query";
import { apiRelLancamentos } from "pages/relatorios/api/apiRelLancamentos";
import { RelatorioContainer } from "pages/relatorios/components/RelatorioContainer";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioGetParams } from "pages/relatorios/types/ApiRelatorioParams";
import { buildRelatorioGetParams } from "pages/relatorios/utils/buildRelatorioGetParams";
import { useEffect, useMemo } from "react";
import type { TExportToCSV } from "std/csv";
import { FilterBar } from "./FilterBar";
import { columns, TableRelLancamentos } from "./TableRelLancamentos";

export type TApiLancamentos = {
	codigo: number;
	data: string;
	entidade: string;
	transportador: string;
	descricao: string;
	fornecedorConveniado?: string;
	quantidade: number;
	tipo: string;
	valorUnitario: number;
	total: number;
};

export function RelatorioLancamentos() {
	const filter = useRelatorioStore((s) => s.filter);

	const limparFiltros = useRelatorioStore((s) => s.limparFiltros);

	const params: ApiRelatorioGetParams = useMemo(() => buildRelatorioGetParams(filter), [filter]);

	const { data, isFetching, refetch } = useQuery({
		queryKey: ["apiRelLancamentos", params],
		queryFn: () => apiRelLancamentos({ params }),
		enabled: false,
	});

	const registros = useMemo(() => data?.registros || [], [data]);

	const csvData: TExportToCSV<TApiLancamentos> = useMemo(() => {
		return {
			type: "default",
			fileName: "relatorio-lancamentos",
			options: {
				columns,
				data: registros,
			},
		};
	}, [registros]);

	useEffect(() => {
		limparFiltros();
	}, [limparFiltros]);

	const title = "Dados de Lançamento";

	return (
		<RelatorioContainer
			breadCrumbs={["Relatórios", "Lançamentos"]}
			refetch={refetch}
			filterBar={<FilterBar />}
			loading={isFetching}
			title={title}
			csvData={csvData}
			registros={registros}
			table={<TableRelLancamentos data={data?.registros} title={title} />}
		/>
	);
}
